import React from 'react';
import PropTypes from 'prop-types';
import { pure } from '@dbk/ui-react-utils';

import AssetItem from '../../../components/asset/asset-item';
import {
  AssetItemHeaderDescription,
} from '../../../components/asset/asset-item/asset-item-header';
import {
  AssetItemDataText,
} from '../../../components/asset/asset-item/asset-item-data';

import TableRow from '../../../components/common/table-row';
import { Large } from '../../../components/common/text';

import { factory } from '../positions/asset-position/asset-position-container';

import { Percent } from '../../../components/common/number';

import defaultStyles from '../positions/asset-position/asset-position.styles';

function CashPosition({ row, columnWidths, screen }) {
  var shorten = false;
  if(screen.isSmall){
    shorten = 30;
  }

  return (
    <AssetItem>
      <TableRow style={defaultStyles.topRow}>
        <TableRow.Column
          align="left"
          width={columnWidths[0] + columnWidths[1]}
          testID="description"
        >
          <AssetItemHeaderDescription
            row={{
              description: row.account,
            }}
            shorten={shorten}
          />
        </TableRow.Column>
      </TableRow>
      <TableRow style={defaultStyles.bottomRow}>
          <TableRow.Column
            align="left"
            width={columnWidths[0]}
          >
            <Large>{row.positionCurrency}</Large>
          </TableRow.Column>
          <TableRow.Column width={columnWidths[1]}>
            <AssetItemDataText value={row.balance} />
          </TableRow.Column>
          <TableRow.Column width={columnWidths[2]}>
            <AssetItemDataText value={row.marketValue} />
          </TableRow.Column>
          {
            !screen.isSmall &&
            <TableRow.Column width={columnWidths[3]}>
              <Percent value={row.proportion}/>
            </TableRow.Column>
          }
      </TableRow>
    </AssetItem>
  );
}

CashPosition.propTypes = {
  row: PropTypes.shape({
    account: PropTypes.string,
    accountCurrency: PropTypes.string,
    balance: PropTypes.number,
    ledgerBalance: PropTypes.number,
  }),
  columnWidths: PropTypes.arrayOf(PropTypes.number).isRequired,
  screen: PropTypes.shape({
    isSmall: PropTypes.bool,
  }),
};

CashPosition.defaultProps = {
  row: {},
};

export default factory({
  component: pure(CashPosition),
  rowFragmentExtend: {
    account: true,
    balance: true,
  },
});
